import {
    forwardRef,
    useImperativeHandle,
} from 'react'

const Welcome = forwardRef(({ company, handleNext }, ref) => {

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            return {
                isValid: true,
                value: {
                    result: true,
                },
            }
        },
    }))

    return (
        <div className="flex flex-col items-center justify-center px-4 py-10">
            <div className="max-w-3xl w-full bg-white shadow-xl rounded-2xl p-8 space-y-6">
                <div className="space-y-2 text-center">
                    <h1 className="text-3xl font-bold text-gray-800">Welcome to PreCheck</h1>
                    <p className="text-lg text-gray-600">
                        Ready to begin?
                    </p>
                </div>

                <div className="text-gray-700 text-base space-y-4">
                    <p>
                        We are using <span className="font-semibold">VerifiedID</span> to conduct a secure, standard PreCheck to move your profile forward for your current placement opportunity. This process establishes a foundation of trust and protects your professional identity.
                    </p>

                    <div className="bg-gray-100 rounded-lg p-4 space-y-2">
                        <p className="font-semibold text-gray-800">Here is a quick overview of the process:</p>
                        <ul className="list-disc list-inside space-y-1 text-gray-700">
                            <li><strong>Agree to Electronic Forms:</strong> Confirm your consent to electronic documents and signatures.</li>
                            <li><strong>Review Legal Disclosures:</strong> Read important information regarding your rights.</li>
                            <li>
                                <strong>Authorize Verification:</strong> Grant permission for the following security layers:
                                <ul className="list-disc list-inside ml-5 mt-1 space-y-1">
                                    <li><strong>Identity Authentication:</strong> Validation of your government-issued identification.</li>
                                    <li><strong>Biometric Comparison:</strong> A facial "Match Selfie" compared against your provided identification.</li>
                                    <li><strong>Identifier Verification:</strong> Confirmation of identifiers such as email and mobile number.</li>
                                </ul>
                            </li>
                            <li>
                                <strong>Provide Electronic Signature:</strong> Complete your forms with a digital signature. To validate your identity, you will be asked to provide:
                                <ul className="list-disc list-inside ml-5 mt-1 space-y-1">
                                    <li>For US residents: The last 4 digits of your SSN.</li>
                                    <li>For non-US residents: The last 4 digits of your National ID.</li>
                                </ul>
                            </li>
                            <li><strong>Submit:</strong> Send your information for processing.</li>
                        </ul>
                    </div>

                    <p className="text-sm text-gray-700 italic">
                        <strong>Note:</strong> To ensure your data is saved correctly, please do not use your browser’s back button once you have started the process.
                    </p>
                </div>

                <div className="text-center">
                    <button
                        className="mt-4 px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold text-lg shadow-md transition-all"
                        onClick={handleNext}
                    >
                        Start Pre Check
                    </button>
                </div>
            </div>
        </div>
    )

})

export default Welcome
